

export default {
  name: "itemStyle",
  nickname: "项样式",
  desc: "<br>",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        '矩形的颜色。默认从全局调色盘 <a target="__blank" href="https://echarts.apache.org/zh/option.html#color">option.color</a> 获取颜色。',
      eType: "color",
    },
    colorAlpha: {
      name: "colorAlpha",
      nickname: "颜色透明度 ",
      desc: "矩形颜色的透明度。取值范围是 0 ~ 1 之间的浮点数。",
    },
    colorSaturation: {
      name: "colorSaturation",
      nickname: "颜色饱和度",
      desc: "矩形颜色的饱和度。取值范围是 0 ~ 1 之间的浮点数。",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc:
        '矩形边框线宽。为 0 时无边框。而矩形的内部子矩形（子节点）的间隔距离是由 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.levels.gapWidth">gapWidth</a> 指定的。',
      value: 0,
      defaultValue: 0,
    },
    gapWidth: {
      name: "gapWidth",
      nickname: "间隔距离",
      desc: "矩形内部子矩形（子节点）的间隔距离。",
      value: 0,
      defaultValue: 0,
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "矩形边框 和 矩形间隔（gap）的颜色。",
      value: "'#fff',",
      defaultValue: "'#fff',",
      type: "pureValue",
    },
    borderColorSaturation: {
      name: "borderColorSaturation",
      nickname: "颜色的饱和度",
      desc: "矩形边框的颜色的饱和度。取值范围是 0 ~ 1 之间的浮点数。",
    },
    strokeColor: {
      name: "strokeColor",
      nickname: "描边颜色",
      desc: "每个矩形的描边颜色。",
    },
    strokeWidth: {
      name: "strokeWidth",
      nickname: "描边宽度",
      desc: "每个矩形的描边宽度。",
    },
  },
}
